var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loading',{attrs:{"active":_vm.bool_fullLoading},on:{"update:active":function($event){_vm.bool_fullLoading=$event}}}),_vm._v(" "),_c('iframe',{ref:"helpframe",attrs:{"src":"https://afbproduct.com/En9Bve9Xg77RULah/","width":"100%","frameborder":"0"},on:{"load":_vm.HelpFrameLoad}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83350c9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/VideoGuide.vue
// module id = null
// module chunks = 